/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import { Component, Prop, Vue } from 'vue-property-decorator';
import {Action} from 'vuex-class';

const namespace: string = 'settingsModule';

/**
 * Cookie consent component.
 *
 * Component that provides a cookie consent banner.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-cookie-consent',
})
export default class CookieConsent extends Vue {
    @Action('consentGiven', {namespace}) public consentGiven: any;
}

